module.exports = __webpack_public_path__ + "static/img/4830_phase_function_Paper_Points.26261f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4830_phase_function_Paper_Points.png
// module id = 6jAF
// module chunks = 0